import { jsx as n } from "react/jsx-runtime";
import i from "clsx";
import { S as t, s as r } from "../../_chunks/SpinnerOverlay.Bcb7POS-.js";
import { SpinnerIcon as S } from "./SpinnerIcon.js";
const N = ({
  absolute: e = !1,
  withOverlay: o = !0,
  blur: p,
  size: m = 64,
  opacity: a = 100,
  color: s,
  overlayClassName: c,
  className: l
}) => /* @__PURE__ */ n(
  t,
  {
    withOverlay: o,
    blur: p,
    absolute: e,
    opacity: a,
    className: c,
    children: /* @__PURE__ */ n(
      "div",
      {
        className: i(
          r.Spinner,
          e && r.Spinner_absolute,
          r[`Spinner_size_${m}`],
          l
        ),
        children: /* @__PURE__ */ n(S, { className: i(r.Spinner__Icon, s && r[`color_${s}`]) })
      }
    )
  }
);
export {
  N as Spinner
};
